import bootstrapNotify from '../../../../../modules/Gull/Framework/bootstrapNotify.js';
import formatters from '../../../../../modules/Gull/Framework/formatters.js';
import validation from '../../../../../modules/Gull/Framework/validation.js';

const premieVerzoekenVerwerken = {

	init: function() {

		// Maak ingegeven waarde van factor veld de juiste opmaak
		$('tr.product-regel input[name=factor],input[name=factorBruto],input[name=kortingPercentage]').on('change', function() {
			var value = $(this).val();
			value = value.replace(',', '.');
			var valueSplit = value.split('.');
			if (valueSplit[0].length == 0) {
				valueSplit[0] = 0;
			}
			if (typeof valueSplit[1] !== 'undefined') {
				valueSplit[1] = valueSplit[1].substring(0, 6);
			}
			$(this).val(valueSplit.join('.'));
		});

		// Bind opslaan button in relatie tab aan valideer functie
		$('.validate-row-ccs').click(function() {
			premieVerzoekenVerwerken.validateRow($(this).closest('tr'), 'success', 0, 1, 0);
		});

		// Bind opslaan button in algemeen tab aan valideer functie
		$('.validate-row-algemeen').click(function() {
			premieVerzoekenVerwerken.validateRow($(this).closest('tr'), 'success', 0, 0, 1);
		});

		// Functie om ccs relatie nummer veld op 0 te zetten
		$('.validate-row-ccs-new').click(function() {
			$($(this).closest('tr')).find('input[name=CCS_relnr]').val('0');
			premieVerzoekenVerwerken.validateRow($(this).closest('tr'), 'success', 0, 1, 0);
		});

		// Bind valideer button aan validateRow functie
		$('.validate-row').click(function() {
			premieVerzoekenVerwerken.validateRow($(this).closest('tr'), 'success', 1, 0, 0);
		});

		// Bind verwijder button aan validateRow functie
		$('.delete-row').click(function() {
			premieVerzoekenVerwerken.validateRow($(this).closest('tr'), 'danger', 1, 0, 0);
		});

		// Valideer alle tabs als pagina geladen wordt
		$('.tab-pane table tbody').each(function() {
			premieVerzoekenVerwerken.validateTab($(this).find('tr').first());
		});

		// Bind functie om aantal ingegeven regels te limmiteren aan opmerkingen veld
		$('textarea[name=opmerkingenOfferte]').keyup(function() {
			premieVerzoekenVerwerken.limitTextarea(this, 5, 55);
		});

		// Functie om geupload bestand op te slaan
		$('#fileUploadField').on('change', function() {
			$('#uploadFileForm').submit();
		});

		// Functie om opmerkingen veld op te slaan
		$('#opmerkingenOpslaan').click(function() {
			$('#formAction').val('');
			$('#opmerkingen').attr('target', '');
			$('#opmerkingen').submit();
		});

		// Functie om offerte uit te brengen
		$('#offerteUitbrengen').click(function() {
			$('#formAction').val('offerteUitbrengen');
			$('#opmerkingen').attr('target', '');
			$('#opmerkingen').submit();
		});

		// Functie om offerte in te zien
		$('#offerteInzien').click(function() {
			$('#formAction').val('offerteInzien');
			$('#opmerkingen').attr('target', '_blank');
			$('#opmerkingen').submit();
		});

		// Functie om offerte in te zien
		$('#offerteHtmlInzien').click(function() {
			$('#formAction').val('offerteHtmlInzien');
			$('#opmerkingen').attr('target', '_blank');
			$('#opmerkingen').submit();
		});

		// TODO: Checken of deze functie relevant is
		$('#vergelijkingInzien').click(function() {
			$('#formAction').val('vergelijkingInzien');
			$('#opmerkingen').attr('target', '_blank');
			$('#opmerkingen').submit();
		});

		// Functie status offerte afwachting op derden adviseur
		$('#offerteAfwachtDerdenAdviseur').click(function() {
			$('#formAction').val('offerteAfwachtDerdenAdviseur');
			$('#opmerkingen').attr('target', '');
			$('#opmerkingen').submit();
		});

		// Functie status offerte afwachting op derden risicodrager
		$('#offerteAfwachtDerdenRisicodrager').click(function() {
			$('#formAction').val('offerteAfwachtDerdenRisicodrager');
			$('#opmerkingen').attr('target', '');
			$('#opmerkingen').submit();
		});

		// Functie status offerte hervatten
		$('#offerteHervatten').click(function() {
			$('#formAction').val('offerteHervatten');
			$('#opmerkingen').attr('target', '');
			$('#opmerkingen').submit();
		});

		// TODO: Checken of deze functie relevant is
		$('#offerteClaim').click(function() {
			$('#formAction').val('offerteClaim');
			$('#opmerkingen').attr('target', '');
			$('#opmerkingen').submit();
		});


		// Functie om checkboxen op regel van checklist te toggelen
		$('.checklist-vraag td:first-child').click(function(e) {
			e.preventDefault();
			var answer = $(this).parent().find('.answer-value').val();
			if (answer == 'ja') {
				$(this).parent().find('input[type=checkbox].nee').click();
			} else if (answer == 'nee') {
				$(this).parent().find('input[type=checkbox].nvt').click();
			} else {
				$(this).parent().find('input[type=checkbox].ja').click();
			}
		});

		// Functie om checkbox op regel van checklist te toggelen
		$('.checklist-vraag input[type=checkbox]').change(function() {
			var checked = $(this).is(':checked');
			$(this).parent().parent().find('input[type=checkbox]').prop('checked', false);
			if (checked) {
				$(this).prop('checked', true);
				var answer = $(this).prop('name').split('_').pop();
				$(this).parent().parent().find('.answer-value').val(answer);
				$(this).parent().parent().find('.answer-feedback').removeAttr('disabled');
			} else {
				$(this).parent().parent().find('.answer-value').val('');
				$(this).parent().parent().find('.answer-feedback').attr('disabled', true);
			}
		});

		// Functie om waarde van checkbox in checklist op te slaan
		$('.checklist-vraag input').change(function() {
			var key = $(this).parent().parent().data('key');
			var vraagkey = $(this).parent().parent().data('vraag-key');
			var value = $(this).parent().parent().find('.answer-value').val();

			var urlSplit = window.location.href.split('#');
			var url = urlSplit[0];
			if (url.charAt(url.length - 1) != '/') {
				url = url + '/';
			}

			var actionArray = [url + 'SaveChecklistRow', key, vraagkey, value, ''];
			var this_row = $(this).parent().parent();
			$.post(actionArray.join('/'), {
				toelichting: $(this).parent().parent().find('.answer-feedback').val()
			}, function(data) {
				if (data == false) {
					var status = 'warning table-warning';
					bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
				} else {
					if (value == '') {
						status = 'warning table-warning';
					} else {
						status = 'success table-success';
					}
				}
				$(this_row).removeClass('warning').removeClass('success').removeClass('danger').removeClass('table-warning').removeClass('table-success').removeClass('table-danger').addClass(status);
				premieVerzoekenVerwerken.validateTab(this_row);
			});

		});

		// Maark link aan die alle checkboxes in de checklist onder specials op n.v.t. checkt
		$('.checklist table tbody tr th').append('&nbsp;&nbsp;<a href="javascript:void(0)" class="link-nvt">n.v.t.</a>');
		$('body').on('click', '.checklist table tbody tr th .link-nvt', function() {
			$(this).closest('tbody').find('.nvt').prop('checked', true).trigger('change');
		});

		// Functie om inhoud van 'Aanpassing Doorvoeren' modal op te slaan
		$('.submit-modal').click(function() {
			var product = $(this).closest('.product-modal').attr('data-product');
			var error = new Array();
			$('form#modalForm' + product + ' input[data-validate],select[data-validate],textarea[data-validate]').each(function() {
				if ($(this).prop('disabled') == false) {
					if (validation.checkInput(this) === 'error') {
						error.push($(this).attr('name'));
					}
				}
			});

			if (error.length > 0) {
				bootstrapNotify('danger', '', 'Er zitten fouten in de velden: <br>' + error.join(',<br>') + '!');
			} else {
				var actionArray = [document.URL, 'SaveModalAanpassing', product, ''];

				var post_data = $('form#modalForm' + product).serialize();

				$.post(actionArray.join('/'), post_data, function(data) {
					if (data == false) {
						bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
					} else {
						$('.modal').modal('hide');
						// $('#showAanpassingTeken' + product).removeClass('d-none');
						// if ($('form#modalForm' + product).find('input[type=checkbox]').is(':checked')) {
						// 	$('#showAanpassingTeken' + product).removeClass('d-none');
						// } else {
						// 	$('#showAanpassingTeken' + product).addClass('d-none');
						// }
					}
				});
			}
			// Maak controleer knop groen als de data in het modal wordt opgeslagen
			$('.product-regel[data-product="' + product + '"]').find('.btn-controleer').removeClass('btn-danger').addClass('btn-success').text('Gecontroleerd');
		});

		// Functie bind aan pulldown
		$('#bmLadderVanToepassing').change(function(e) {
			e.preventDefault();
			premieVerzoekenVerwerken.bmLadderVanToepassing();
		});

		// Functie bind aan pulldown
		$('#holdingVanToepassing').change(function(e) {
			e.preventDefault();
			premieVerzoekenVerwerken.holdingVanToepassing();
		});

		// Run functie on keyup
		$('body').on('keyup', '#NR_EXTERN,#CCS_relnr', function() {
			premieVerzoekenVerwerken.compareCSSFields();
		});

		// Bind 'toevoegen' knop aan functie om tabelregel toe te voegen
		$('.modal .form-section').on('click', 'button.btn-add', function(e) {
			premieVerzoekenVerwerken.addTableRow($(e.target));
		});

		// Bind 'toevoegen' knop aan functie om tabelregel toe te voegen
		$('.modal .form-section').on('click', '.btn-remove', function(e) {
			premieVerzoekenVerwerken.removeTableRow($(e.target).closest('tr'));
		});

		// KortingPercentage limiteren op 0-10
		$('[name=kortingPercentage]').on('blur', function() {
			premieVerzoekenVerwerken.formatLimitKorting($(this));
		});

		// Maak regel onklaar als input gefocused wordt
		$('.product-regel input').on('focus', function() {
			premieVerzoekenVerwerken.validateRow($(this).closest('tr'), 'warning', 0, 0, 0);
		});

		// Bind loyalisCombinatieKorting select aan cunctie om combinatiekorting gekozen in modal toe te passen op productregel
		$('[data-korting]').on('keyup change', function(event) {
			premieVerzoekenVerwerken.pasKortingToeOpProductregel(event);
		});

		//
		$('[data-korting]').on('change', function(event) {
			var target = $(event.target);
			var modal = target.closest('.product-modal');
			var productNumber = modal.attr('data-product');
			var productRow = $('.product-regel[data-product=' + productNumber + ']');
			premieVerzoekenVerwerken.validateRow(productRow, 'warning', 0, 0, 0);
		});

		// Trigger korting functie als modal geladen wordt
		$('.product-modal').on('shown.bs.modal', function(event) {
			$(event.target).find('[data-korting]').trigger('keyup');
		});

		// Functie om de bedrijfsnaam in de DOM te wijzigen als deze wordt opgeslagen
		$('[name=bedrijfsnaamOrigineel]+button.validate-row-algemeen').click(function() {
			var bedrijfsnaamOrigineel = $('#tab_ccs input[name=bedrijfsnaamOrigineel]').val();
			$('#tab_ccs input[name=NM_RELATIE]').val(bedrijfsnaamOrigineel);
		});

		// Bind functie om de inhoud van opmerkingen te schonen aan veld
		$('#opmerkingenAcceptatie').blur(function(e) {
			e.preventDefault();
			premieVerzoekenVerwerken.sanitizeOpmerkingen(e);
		});

		// Bind upload button click functie
		$('#fileUploadButton').click(function(e) {
			$('#fileUploadField').click();
			e.preventDefault();
		});

		// Functie uitvoeren wanneer pagina geladen wordt
		premieVerzoekenVerwerken.bmLadderVanToepassing();

		// Functie uitvoeren wanneer pagina geladen wordt
		premieVerzoekenVerwerken.holdingVanToepassing();

		// Run functie on pageload
		premieVerzoekenVerwerken.compareCSSFields();

		// Activate first tab
		var firstTabEl = document.querySelector('.premie-validatie-tabs li:first-child a');
		if (firstTabEl !== null) {
			var firstTab = new bootstrap.Tab(firstTabEl);
			firstTab.show();
		}

		// Tab dropdowns
		document.addEventListener('click', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('[data-bs-toggle=tabDropdown]')) {
					var targetTab = event.target.getAttribute('data-bs-target-tab');
					var tabEl = document.querySelector('.premie-validatie-tabs li[data-tab="' + targetTab + '"] a');
					new bootstrap.Tab(tabEl).show();
					break;
				}
			}
		}, false);


	},

	// Functie om volledige premieverzoek te valideren
	validateComplete: function() {

		// Valideer alle premieverzoeken van alle maatschappijen
		if ($('.tab-pane table tbody').children().hasClass('warning')) {

			// Maak de offerte-buttons disabled als er warnings zijn
			$('ul.nav-tabs.premie-validatie-tabs button#offerteUitbrengen').attr('disabled', true);

		} else {

			// Maak object met per product alle maatschappijen
			var Producten = {};
			$('.product-regel.table-success').each(function(key, this_row) {
				var product = $(this_row).attr('data-product');
				var Mij = $(this_row).attr('data-Mij');

				if (Producten[product] === undefined) {
					Producten[product] = {};
				}
				Producten[product][Mij] = 1;
			});

			// Controleer of er maximaal 6 maatschappijen per product geselecteerd zijn
			var fouten = '';
			for (var key in Producten) {
				if (Producten.hasOwnProperty(key)) {
					var aantal = Object.keys(Producten[key]).length;
					if (aantal > 6) {
						fouten = fouten + key + ' heeft ' + aantal + ' geselecteerde maatschapijen en 6 is het maximum<br/>';
					}
				}
			}

			// Maak de offerte-buttons enabled als er geen fouten zijn
			if (fouten == '') {
				$('ul.nav-tabs.premie-validatie-tabs button#offerteUitbrengen').attr('disabled', false);

				// Maak de offerte-buttons disabled als er geen fouten zijn en toon waarschuwing
			} else {
				$('ul.nav-tabs.premie-validatie-tabs button').attr('disabled', true);
				bootstrapNotify('danger', 'Let op:', fouten);
			}
		}

	},

	// Functie om alle regels in tab te valideren
	validateTab: function(this_row) {
		var tab = $(this_row).closest('div.tab-pane').attr('data-tab');

		// Valideer de huidige tabel op openstaande premieverzoeken
		if ($(this_row).closest('.tab-pane[data-tab=' + tab + '] table tbody').children().hasClass('warning')) {

			// Maak de maatschappij tab grijs
			$('ul.nav-tabs li[data-tab=' + tab + '] a.maatschapij-tab').removeClass('bg-warning').removeClass('bg-success').addClass('bg-warning bg-opacity-25');
		} else {

			// Maak de maatschappij tab groen
			$('ul.nav-tabs li[data-tab=' + tab + '] a.maatschapij-tab').removeClass('bg-warning').removeClass('bg-success').addClass('bg-success bg-opacity-25');
		}

		// Voer volledige validatie uit van premieverzoek
		premieVerzoekenVerwerken.validateComplete();
	},

	// Sla dekkingsregel op
	SaveRow: function(this_row, status) {

		var product = $(this_row).attr('data-product');
		var Mij = $(this_row).attr('data-Mij');
		var dekking = $(this_row).attr('data-dekking');
		var factorBruto = $(this_row).find('input[name=factorBruto]').val();
		var grondslag = $(this_row).find('input[name=grondslag]').val();
		var kortingPercentage = $(this_row).find('input[name=kortingPercentage]').val();

		var polis_id = $('[data-polis-id]').attr('data-polis-id');
		var url = window.app.ajaxPath + polis_id + '/1';

		var actionArray = [url, 'SaveRow', product, Mij, dekking, status, factorBruto, grondslag, kortingPercentage, ''];

		$.getJSON(actionArray.join('/'), function(data) {
			if (data == false) {
				premieVerzoekenVerwerken.validateRow(this_row, 'warning', 0, 0, 0);
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
			} else {
				$(this_row).find('input[name=factorBruto]').val(data.factorBruto);
				$(this_row).find('input[name=grondslag]').val(data.grondslag);
				$(this_row).find('input[name=kortingPercentage]').val(data.kortingPercentage);
				$(this_row).find('span.factorNetto').html(data.factorNetto);
				$(this_row).find('span.premieNetto').html(data.premieNetto);
				$(this_row).find('span.premieBruto').html(data.premieBruto);
			}
		});
	},

	// Functie om regel in relatie tab op te slaan
	SaveRowCCS: function(this_row) {
		var field = $(this_row).find('input').attr('name');
		var value = $(this_row).find('input').val();

		var actionArray = [document.URL, 'SaveRowCCS', field, value, ''];

		$.getJSON(actionArray.join('/'), function(data) {
			if (data == false) {
				premieVerzoekenVerwerken.validateRow(this_row, 'warning', 0, 0, 0);
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens');
			}
		});
	},

	// Functie om regel in algemeen tab op te slaan
	SaveRowAlgemeen: function(this_row) {
		var field = $(this_row).find('input,select').attr('name');
		var value = $(this_row).find('input,select').val();

		var actionArray = [document.URL, 'SaveRowAlgemeen', field, value, ''];

		$.getJSON(actionArray.join('/'), function(data) {
			if (data == false) {
				premieVerzoekenVerwerken.validateRow(this_row, 'warning', 0, 0, 0);
				bootstrapNotify('danger', '', 'Er is iets fout gegaan met het opslaan van de gegevens!');
			}
		});
	},

	// Functie om regel te valideren
	validateRow: function(this_row, status, save, saverelatie, savealgemeen) {
		if ($(this_row).hasClass(status) && saverelatie == 0 && savealgemeen == 0) {
			// kleur de rij(this_row) oranje
			$(this_row).removeClass(status).addClass('warning');
			status = 'warning';
		}

		$(this_row).removeClass('warning').removeClass('table-warning').removeClass('table-success').removeClass('table-danger').addClass(status).addClass('table-' + status);

		if (save == 1) {
			premieVerzoekenVerwerken.SaveRow(this_row, status);
		}

		if (saverelatie == 1) {
			premieVerzoekenVerwerken.SaveRowCCS(this_row, status);
		}

		if (savealgemeen == 1) {
			premieVerzoekenVerwerken.SaveRowAlgemeen(this_row, status);
		}

		premieVerzoekenVerwerken.validateTab(this_row);
	},

	// Functie om aantal ingegeven regels in texareas te limiteren
	limitTextarea: function(textarea, maxLines, maxChar) {
		var lines = textarea.value.replace(/\r/g, '').split('\n'),
			lines_removed, char_removed, i;
		if (maxLines && lines.length > maxLines) {
			lines = lines.slice(0, maxLines);
			lines_removed = 1;
		}
		if (maxChar) {
			i = lines.length;
			while (i-- > 0)
				if (lines[i].length > maxChar) {
					lines[i] = lines[i].slice(0, maxChar);
					char_removed = 1;
				}
			if (char_removed || lines_removed) {
				textarea.value = lines.join('\n');
			}
		}
	},

	// Functie om waarden in css velden te vergelijken en tekst een kleur te geven
	compareCSSFields: function() {
		if ($('#NR_EXTERN').val() != $('#CCS_relnr').val()) {
			$('#NR_EXTERN,#CCS_relnr').addClass('text-danger');
			$('#NR_EXTERN,#CCS_relnr').removeClass('text-success');
		} else {
			$('#NR_EXTERN,#CCS_relnr').removeClass('text-danger');
			$('#NR_EXTERN,#CCS_relnr').addClass('text-success');
		}
	},

	// Functie om de BM ladder velden in de gegevens model te tonen of the verbergen
	bmLadderVanToepassing: function() {
		if ($('#bmLadderVanToepassing').val() == '1') {
			$('.form-section.form-section-bm-ladder').removeClass('d-none');
		} else {
			$('.form-section.form-section-bm-ladder').addClass('d-none');
		}
	},

	// Functie om de holding velden in de gegevens model te tonen of the verbergen
	holdingVanToepassing: function() {
		if ($('#holdingVanToepassing').val() == '1') {
			$('.form-section.form-section-holding').removeClass('d-none');
		} else {
			$('.form-section.form-section-holding').addClass('d-none');
		}
	},

	// Functie om tabelregel toe te voegen
	addTableRow: function(targetElement) {

		// Definieer table body
		var tableBody = targetElement.closest('.form-section').find('table tbody');

		// Dupliceer de eerste regel
		var nr = tableBody.find('tr').first().clone()
			// Maak alle waardes leeg
			.find('input,select').val('')
			// Maak het element zichtbaar
			.closest('tr').removeClass('d-none');

		// Plaats het bij de rest van de dekkingen
		nr.appendTo(tableBody);

		// Init datepicker
		$(nr).find('.datepicker').datepicker({
			format: 'dd-mm-yyyy',
			language: window.app.language.replace('_', '-'),
			autoclose: true,
			forceParse: false,
			enableOnReadonly: false
		});

		premieVerzoekenVerwerken.nameRowInputs(targetElement);

	},

	// Functie om input velden in rows het juiste name attribute te geven
	nameRowInputs: function(targetElement) {

		// Definieer table body
		var tableRows = targetElement.closest('.form-section').find('table tbody tr');

		// Geef op elke row elke input een name attribute met nummer
		tableRows.each(function(rowIndex) {
			$(this).find('input').each(function() {
				var inputName = $(this).data('name') + rowIndex;
				$(this).attr('name', inputName);
			});
		});

	},

	// Functie om tabelregel te verwijderen
	removeTableRow: function(targetRow) {
		var tableBody = targetRow.closest('.form-section').find('table tbody');
		$('[data-toggle=tooltip]').tooltip('hide');
		targetRow.find('input').attr('value', '');
		targetRow.hide();
		premieVerzoekenVerwerken.nameRowInputs(tableBody);
	},

	// Number limiteer
	formatLimitKorting: function(t) {

		// Verkrijg maximale korting
		var m = t.data('max-korting') || 0.00;

		// Verkrijg huidige waarde
		var v = t.val();

		// Var returnValue
		var r;

		// Limiteer op max korting of geef oorspronkelijke waarde terug
		if (parseFloat(t.val()) > m) {
			r = ((0.00 + parseFloat(m)).toFixed(2));
		} else if (t.val() < 0) {
			r = ((0.00).toFixed(2));
		} else {
			r = (0.00 + parseFloat(v)).toFixed(2);
		}

		// Return de waarde
		t.val(r);
	},

	// Functie om combinatiekorting gekozen in modal toe te passen op productregel
	pasKortingToeOpProductregel: function(event) {
		var target = $(event.target);
		var modal = target.closest('.product-modal');
		var productNumber = modal.attr('data-product');
		var productRow = $('.product-regel[data-product=' + productNumber + '] [name=kortingPercentage]');
		var totaleKortingVeld = modal.find('[name=loyalisKortingTotaal]');
		var kortingsVelden = modal.find('[data-korting]');
		var totaleKorting = 0;
		$.each(kortingsVelden, function(index, element) {
			var value = $(element).val() || 0;
			var value = formatters.cleanString2CorrectNumber(value);
			totaleKorting = (((parseFloat(totaleKorting) * 100) + (parseFloat(value) * 100)) / 100).toFixed(2);
		});
		productRow.val(totaleKorting);
		totaleKortingVeld.val(formatters.dotToComma(totaleKorting));
		productRow.trigger('blur');
	},

	// Functie om de inhoud van opmerkingen te schonen
	sanitizeOpmerkingen: function(e) {
		var target = $(e.target);
		var value = target.val();
		var returnValue = formatters.sanitizeString(value);
		target.val(returnValue);
	}

};

export default premieVerzoekenVerwerken;
